import React, { createContext, useContext, useState } from 'react';

const SidePanelContext = createContext();

export const SidePanelProvider = ({ children }) => {
  const [isPanelOpen, setIsPanelOpen] = useState(false);

  return (
    <SidePanelContext.Provider value={{ isPanelOpen, setIsPanelOpen }}>
      {children}
    </SidePanelContext.Provider>
  );
};

export const useSidePanel = () => {
  const context = useContext(SidePanelContext);
  if (!context) {
    throw new Error('useSidePanel must be used within a SidePanelProvider');
  }
  return context;
};